// extracted by mini-css-extract-plugin
export default {"root":"QlVPgZym","hidden":"YMl6tuqD","button":"A4iuMrwm","active":"lTI19L4Y","icon":"Q6nK70OA","label":"Hzc2OPCD"};